import { apiClient } from '@copro/api'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import z from 'zod'
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore'
import { useRouterLinkClick } from '../../../hooks/useRouterLinkClick'

const formSchema = z.object({
  password: z.string().min(1, 'Mot de passe requis'),
})

type FormValues = z.infer<typeof formSchema>

/** Error sent back by Supabase in the URL hash when the recovery link is expired or invalid. */
function readLinkError(): string | null {
  const hash = window.location.hash
  if (!hash) {
    return null
  }
  return new URLSearchParams(hash.substring(1)).get('error_description')
}

export function useResetPasswordPage() {
  const navigate = useNavigate()
  const [linkError, setLinkError] = useState<string | null>(null)
  const [serverError, setServerError] = useState<string | null>(null)
  const handleBackClick = useRouterLinkClick('/login')
  const handleRequestNewLinkClick = useRouterLinkClick('/forgot-password')

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: { password: '' },
  })

  useEffect(() => {
    setLinkError(readLinkError())
  }, [])

  async function updatePassword(data: FormValues) {
    setServerError(null)

    const { error } = await apiClient.auth.updateUser({ password: data.password })

    if (error) {
      setServerError(error.message)
      return
    }
    enqueueSnackbar('Mot de passe mis à jour', 'success')
    await apiClient.auth.signOut()
    navigate('/login')
  }

  return {
    form,
    linkError,
    serverError,
    isSubmitting: form.formState.isSubmitting,
    handleSubmit: form.handleSubmit(updatePassword),
    handleBackClick,
    handleRequestNewLinkClick,
  }
}
